import Modal from "./Modal";
import icon_warning from "../assets/icons/modal-delete-icon.svg";
const DeleteItem = (props) => {
  const { destroy, reset, isModal, item } = props;
  const handleBack = () => {
    reset();
  };
  const handleDelete = () => {
    destroy();
  };
  return (
    <Modal data={"modal-delete"} back={handleBack} isModal={isModal}>
      <div
        data-cy="todo-modal-delete"
        className="flex flex-col items-center justify-evenly w-[490px] h-[355px]"
      >
        <img
          data-cy="modal-delete-icon"
          className="w-[84px] items-center"
          src={icon_warning}
        />
        <h1 className="text-center text-[18px]">
          Apakah anda yakin menghapus list item "
          <span className="font-bold">{item?.title}</span>"?
        </h1>
        <div className="flex flex-row justify-center gap-5">
          <button
            data-cy="modal-delete-cancel-button"
            onClick={() => handleBack()}
            className="bg-[#F4F4F4] text-sans w-[150px] h-[54px] hover:bg-gray-400 text-black font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
          >
            Back
          </button>
          <button
            data-cy="modal-delete-confirm-button"
            onClick={() => handleDelete()}
            className="bg-[#ED4C5C] text-sans w-[150px] h-[54px] hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
          >
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteItem;
